import styled from 'styled-components/macro';
import { smallFont } from '../helpers';

const Label = styled.label`
  ${smallFont};
  
  display: block;
  color: ${props => props.theme.mutedText};
`;

export default Label;
